import gql from 'graphql-tag';

export const listTimeline = gql`
  mutation monitoringTimeline($condominiumPersonContextId: ID!) {
    monitoringTimeline(condominiumPersonContextId: $condominiumPersonContextId)
  }
`;
